<template>
  <div>
    <div class="ccui-app-container-detail2">
      <div ref="detailBody" class="ccui-app-container-detail-body">
        <!-- 历史质疑列表 -->
        <el-group-title :title="$t('page.content.QuestionList')">
          <template slot="groupTitle">
            <attachmentUpload
              :fileData="tableData"
              :type="2"
            ></attachmentUpload>
          </template>
        </el-group-title>
        <!-- 供应商质疑 -->
        <el-group-title :title="$t('page.content.subcontractorQuestions')">
          <template slot="groupTitle">
            <attachmentUpload
              :fileData="tableData1"
              :type="1"
              ref="tableData1"
            ></attachmentUpload>
          </template>
        </el-group-title>
      </div>
    </div>
    <div class="operate" :style="{ width: width }">
      <el-button type="text" icon="icon-ccui-agree" @click="submit">{{
        $t("page.content.Submit1")
      }}</el-button>
    </div>
  </div>
</template>

<script>
import {
  qrySupQuestionListSub,
  dealSupQuestionSubmitSub
} from "@/app/myProjects/api/myProjectsEl.js";

import attachmentUpload from "@/basa/components/common/attachmentUploadSub.vue";
export default {
  name: "supplierChallengeSub",
  components: {
    attachmentUpload
  },
  mounted() {
    this.width = this.$refs["detailBody"].scrollWidth + "px";
    this.agentId = this.$router.history.current.query.a;
    this.schemeId = sessionStorage.getItem("schemeId");
    this.getSupQuestionList();
  },
  data() {
    return {
      width: "1000px",
      agentId: "",
      schemeId: "",
      tableData1: [],
      tableData: [],
      supCode: sessionStorage.getItem("subcontractorCode"),
      supName: sessionStorage.getItem("subcontractorName")
    };
  },
  methods: {
    getSupQuestionList() {
      let params = Object.assign(
        {},
        { agentId: this.agentId },
        { schemeId: this.schemeId },
        { supCode: this.supCode },
        { pageNo: -1 },
        { pageSize: -1 }
      );
      qrySupQuestionListSub(params).then(res => {
        if (res) {
          let obj = {
            isShowTag: false,
            isShowexeTime: false,
            isShowLeftTime: false,
            isShowCouTime: false
          };
          this.$store.commit("edit", obj);
          this.tableData = [];
          res.data.data.rows.forEach(item => {
            this.tableData.push(...item.fileinfoBOS);
          });
        }
      });
    },
    //提交
    submit() {
      let upFileList = this.$refs.tableData1.fileData;
      let params = Object.assign(
        {},
        { agentId: this.agentId },
        { schemeId: this.schemeId },
        { supCode: this.supCode },
        { supName: this.supName },
        { FileInfoBOs: upFileList }
      );
      if (upFileList.length == 0) {
        // 请上传质疑文件后提交
        this.$message({
          message: this.$t("page.content.Questions1"),
          type: "warning",
          duration: 3000,
          offset: document.documentElement.clientHeight / 2 - 21
        });
      } else {
        // 您是否确认提交质疑
        this.$confirm(
          this.$t("page.content.Submitted1"),
          this.$t("page.content.Submit1"),
          {
            distinguishCancelAndClose: true,
            confirmButtonText: this.$t("page.content.sure1"),
            cancelButtonText: this.$t("page.content.cancel"),
            customClass: "ccui-message-box-custom"
          }
        ).then(() => {
          params.isShowLoading = true;
          dealSupQuestionSubmitSub(params).then(res => {
            if (res) {
              this.tableData1 = [];
              this.getSupQuestionList();
              // 提交成功
              this.$message({
                message: this.$t("page.content.Submitted3"),
                type: "success",
                duration: 3000,
                offset: document.documentElement.clientHeight / 2 - 21
              });
            }
          });
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.noBegin {
  display: flex;
  justify-content: center;
  height: 500px;
  align-items: center;
  font-size: 18px;
  color: #4a4a4a;
}
.tableDetail {
  margin-top: 10px;
  padding: 10px 0px;
  border: 1px solid #edf2fc;
  .top {
    padding: 10px 10px;
    color: #4a4a4a;
    .name {
      padding-right: 20px;
      font-size: 14px;
    }
  }
  .center {
    padding: 10px 10px;
    color: #4a4a4a;
    font-size: 14px;
  }
  .footer {
    padding: 10px 10px;
    color: #4a4a4a;
    font-size: 14px;
    .chlidName {
      padding-bottom: 10px;
    }
    .tableBox {
      padding: 0px 20px;
    }
  }
}
// 底部按钮end
.operate {
  position: fixed;
  width: calc(100% - 270px);
  bottom: 20px;
  z-index: 999;
  height: 40px;
  background: rgba(76, 76, 76, 0.8);
  text-align: center;
  .el-button {
    color: white;
  }
}
// 底部按钮
</style>
